var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.275 8.89208C11.0125 9.14833 10.8625 9.51709 10.9 9.91084C10.9563 10.5858 11.575 11.0796 12.25 11.0796H13.4375V11.8233C13.4375 13.1171 12.3812 14.1733 11.0875 14.1733H3.9125C2.61875 14.1733 1.5625 13.1171 1.5625 11.8233V7.6171C1.5625 6.32335 2.61875 5.26709 3.9125 5.26709H11.0875C12.3812 5.26709 13.4375 6.32335 13.4375 7.6171V8.5171H12.175C11.825 8.5171 11.5063 8.65458 11.275 8.89208Z",
    stroke: "#30322C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5625 8.17965V5.32344C1.5625 4.57969 2.01875 3.91716 2.7125 3.65466L7.675 1.77966C8.45 1.48591 9.28125 2.06093 9.28125 2.89218V5.26717",
    stroke: "#30322C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1002 9.15456V10.4421C14.1002 10.7859 13.8252 11.0671 13.4752 11.0796H12.2502C11.5752 11.0796 10.9565 10.5858 10.9002 9.91083C10.8627 9.51708 11.0127 9.14832 11.2752 8.89207C11.5065 8.65457 11.8252 8.51709 12.1752 8.51709H13.4752C13.8252 8.52959 14.1002 8.81081 14.1002 9.15456Z",
    stroke: "#30322C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 7.92334H8.75",
    stroke: "#30322C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.070d692a8320f6a271c7d72a9eac4b0b.svg";
export { ForwardRef as ReactComponent };